import {
  useGetSession,
  getGetSessionQueryKey,
} from "@workspace/api-client-react";

export interface ChildPlayerStatus {
  isChild: boolean;
  isLoading: boolean;
  isAuthenticated: boolean;
}

export function useIsChildPlayer(): ChildPlayerStatus {
  const session = useGetSession({
    query: { queryKey: getGetSessionQueryKey(), retry: false },
  });
  const data = session.data;
  return {
    isChild: data?.role === "child",
    isLoading: session.isLoading,
    isAuthenticated: data?.authenticated === true,
  };
}

export default useIsChildPlayer;
